module.exports = require('./helpers/bundle-url').getBundleURL('1o0dO') + "compass-empty-state-card-dark-mode.73fed670.svg";